import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { IDI_PROJECT_SEARCH_START_LOADING, IDI_PROJECT_SEARCH_END_LOADING, IDI_PROJECT_SEARCH_LOADED, SET_IDI_PROJECT_FILTER } from "../constants/IdiProjectConstants";
import { IDI_PROJECT_START_LOADING, IDI_PROJECT_END_LOADING, IDI_PROJECT_LOADED } from "../constants/IdiProjectConstants";

const initialState = {
    loading: false,
    list: {   
        dataList: []
        , searchList: []
        , totalCount: 0
    },
    filter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
    },
    loadingFBO: false,
    fbo: null
};

const IdiProjectReducer = (state = initialState, action) => {
    switch(action.type) {
        case IDI_PROJECT_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case IDI_PROJECT_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case IDI_PROJECT_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_IDI_PROJECT_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case IDI_PROJECT_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case IDI_PROJECT_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case IDI_PROJECT_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        default:
            return state;
    }
}

export default IdiProjectReducer;